/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { PageContentMessage } from "../../../messages";

const MODULE_NAME =
  "services.CollectionPageService.machines.GetPageContent.state.checkIfLeafNode";
const log = LoggerModule?.getInstance();

export const checkIfLeafNode = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as PageContentMessage;
      msg.isLeafNode = msg?.children?.totalCount === 0;
      if (msg.isLeafNode) {
        return resolve(true);
      }
      return reject(false);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in checkIfLeafNode", err);
      return reject(err?.message);
    }
  });
};
